import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import "./Accueil.css";

import { Link } from "react-router-dom";

import Img1 from "../../assets/img/Accueil/Contact1-1.png";
import Img2 from "../../assets/img/Accueil/Contact1-2.png";
import Img3 from "../../assets/img/Accueil/Contact1-3.png";
import Img4 from "../../assets/img/Accueil/Contact1-4.png";

gsap.registerPlugin(ScrollTrigger);

export default function Contact1() {
  const sectionRef = useRef(null);
  const { t } = useTranslation();

  const Fiches = [
    {
      id: "uiux-a",
      title: t("contact1.uiuxTitle"),
      texte: t("contact1.uiuxText"),
      img: Img1,
    },
    {
      id: "uiux-b",
      title: t("contact1.uiuxTitle"),
      texte: t("contact1.uiuxText"),
      img: Img1,
    },
    {
      id: "web-1",
      title: t("contact1.uiuxTitle"),
      texte: t("contact1.uiuxText"),
      img: Img4,
    },
    {
      id: "web-2",
      title: t("contact1.webTitle"),
      texte: t("contact1.webText"),
      img: Img3,
    },
    {
      id: "web-3",
      title: t("contact1.webTitle"),
      texte: t("contact1.webText"),
      img: Img2,
    },
    {
      id: "web-4",
      title: t("contact1.webTitle"),
      texte: t("contact1.webText"),
      img: Img2,
    },
  ];

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const cards = gsap.utils.toArray(".Accueil-Contact .Card");
      if (!cards.length) return;

      gsap.set(cards, { autoAlpha: 1, pointerEvents: "auto" });

      const tl = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: `+=${(cards.length - 1) * 100}%`,
          pin: true,
          scrub: 1,
          markers: false,
          invalidateOnRefresh: true,
        },
      });

      cards.forEach((card, i) => {
        if (i === cards.length - 1) return;
        tl.to(card, { autoAlpha: 0, pointerEvents: "none", duration: 0.25 }, i);
      });

      const refresh = () => ScrollTrigger.refresh();
      window.addEventListener("load", refresh);

      const imgs = sectionRef.current?.querySelectorAll("img") ?? [];
      imgs.forEach((img) => {
        if (!img.complete)
          img.addEventListener("load", refresh, { once: true });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={sectionRef} className="Accueil-Contact Contact1">
      {Fiches.map((f, i) => (
        <div key={f.id} className="Card" id={`Card-${f.id}`} data-i={i}>
          <div className="Left">
            <h3>{f.title}</h3>
            <p>{f.texte}</p>
            <Link to="/contact" className="websiteBtn">
              {t("contact1.button")}
            </Link>
          </div>
          <div className="Right">
            <img src={f.img} alt="" />
          </div>
        </div>
      ))}
    </div>
  );
}
